import { Grid, useTheme } from "@mui/material";
import _ from "lodash";
import moment, { Moment } from "moment";
import React, { useCallback } from "react";
import AcxCalendarButton from "./AcxCalendarButton";

interface AcxDatePickerProps {
    id?: string;
    onCalendarClick: () => void;
    onDateChange: (dt: Moment) => void;
    selectedDate?: moment.Moment;
    onBlur?: () => void;
    onFocus?: () => void;
    disabled?: boolean;
    inputStyle?: React.CSSProperties;
}

export default function AcxDatePicker(props: AcxDatePickerProps) {
    const theme = useTheme();
    const [dtValue, setDtValue] = React.useState<string>(
        props.selectedDate ? props.selectedDate.format("l") : "",
    );
    const onClick = () => {
        props.onCalendarClick();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    let debouncedThing = useCallback(
        _.debounce(props.onDateChange, 700),
        [props.onDateChange],
    );

    const onTextChange = (el: React.ChangeEvent<HTMLInputElement>) => {
        const val = el.target.value;

        if (val !== dtValue) {
            try {
                const dt = moment(val, "M/D/YYYY");
                setDtValue(val);
                // debugger;
                const reg =
                    /^([1-9]|[1][0-2])\/([1-9]|[1-2][0-9]|[3][0-1])\/(19|20)\d{2}$/;
                const fmtTest = reg.test(val);
                if (dt.isValid() && fmtTest) {
                    debouncedThing.cancel();
                    debouncedThing(dt);
                    // props.onDateChange?.(dt);
                }
            } finally {
            }
        }
    };

    React.useEffect(() => {
        function doDate() {
            if (!props.selectedDate) {
                setDtValue("");
            } else if (
                props.selectedDate?.format("l") !== dtValue &&
                props.selectedDate !== undefined
            ) {
                setDtValue(props.selectedDate?.format("l"));
            }
        }

        doDate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedDate]);
    const onBlur = () => {
        props.onBlur?.();
    };
    const onFocus = () => {
        props.onFocus?.();
    };
    return (
        <Grid
            container
            direction={"row"}
            sx={{ border: "none", height: "32px", alignItems: "center" }}
            spacing={0}
        >
            <input
                id={props.id}
                type="text"
                disabled={props.disabled}
                onChange={onTextChange}
                onBlur={onBlur}
                onFocus={onFocus}
                value={dtValue}
                style={{
                    border: "1px solid",
                    borderColor: theme.palette.black.light,
                    backgroundColor: theme.palette.white.main,
                    width: "calc(100% - 32px)",
                    fontSize: "14px",
                    lineHeight: "28px",
                    fontFamily: theme.typography.fontFamily,
                    paddingLeft: "6px",
                    ...props.inputStyle,
                }}
            />

            <AcxCalendarButton onClick={onClick} disabled={props.disabled} />
        </Grid>
    );
}
